import { useOutletContext } from "react-router-dom";

import { Stack } from "@mui/material";
import { FormikErrorNotification, SaveBar } from "@shared";

import { CounselorResponse } from "@/api";
import { useTranslation } from "@/translations";

import { BlockedPeriodsCard } from "./components/blocked-periods-card/BlockedPeriodsCard";
import { CourtPreferencesCard } from "./components/court-preferences-card/CourtPreferencesCard";
import { DutyPreferencesCard } from "./components/duty-preferences-card/DutyPreferencesCard";
import { useCounselorDutyPreferences } from "./hooks/useCounselorDutyPreferences";

export function CounselorDutyPreferences() {
  const { t } = useTranslation();
  const counselor = useOutletContext<CounselorResponse>();

  const { formik, courtOptions, dutyTypeOptions, handleAddBlockedPeriod, handleDeleteBlockedPeriod } =
    useCounselorDutyPreferences(counselor.counselorId);

  return (
    <Stack component="form" onSubmit={formik.handleSubmit} sx={{ flex: 1, maxHeight: "100%", gap: 1 }}>
      <FormikErrorNotification formik={formik} />

      <Stack flex={1} gap={1} sx={{ overflowY: "auto" }}>
        <CourtPreferencesCard formik={formik} courtOptions={courtOptions} />
        <DutyPreferencesCard formik={formik} />
        <BlockedPeriodsCard
          formik={formik}
          dutyTypeOptions={dutyTypeOptions}
          onAdd={handleAddBlockedPeriod}
          onDelete={handleDeleteBlockedPeriod}
        />
      </Stack>

      <SaveBar
        resetLabel={t("common.resetChanges")}
        onReset={formik.handleReset}
        resetDisabled={formik.isSubmitting || !formik.dirty}
        saveLabel={t("common.save")}
        saveDisabled={formik.isSubmitting || !formik.dirty}
      />
    </Stack>
  );
}
